module.exports = __webpack_public_path__ + "static/media/argentina_mototurismo_1.2d7c1c2e.jpg";